export default {
  agentLevelMap: {
    0: '注册伙伴',
    1: '正式伙伴',
  },
  customerLevelMap: {
    0: '注册用户',
    1: '正式用户',
    2: '实名用户',
    3: '实名企业',
  },
}
